export default "__VITE_ASSET__BetHx8UG__"